import React, { useContext, useMemo, useState } from "react";
import OTPAuthContext from "./OTPAuthContext";
import { toast } from "react-toastify";
import axios from "axios";
import { useNavigate } from "react-router";
import DataContext from "./DataContext";
import getURLS from "../utils/helper";

function OTPAuthProvider({ children }) {
  const {
    setToken,
    timeLeft,
    setTimeLeft,
    canResend,
    setCanResend,
    otpFieldVisible,
    setOtpFieldVisible,
  } = useContext(DataContext);

  const [errors, setErrors] = useState({ error: false, errorText: "" });
  const [mobNumber, setMobNumber] = useState("");
  const [otp, setOtp] = useState("");
  const [expiredErr, setExpiredErr] = useState(null);
  const [otpGettingLoad, setGettingLoad] = useState(false);

  const navigate = useNavigate();
  const otpValidity = 300;

  const handleOTP = (e) => {
    const { value, name } = e.target;
    if (value?.length !== 10) {
      setErrors({ error: true, errorText: "Invalid Mobile No." });
    } else {
      setErrors({ error: false, errorText: "" });
    }
    setMobNumber(value);
  };

  // send otp

  const onSendOtp = () => {
    setGettingLoad(true);
    axios
      .post(`${getURLS().otpApiURL}/api/v1/PII/otpviaphone`, {
        length: 6,
        appId: getURLS().otpAppURL,
        phone: mobNumber,
        validTime: 2,
        applicationName: "DATA ENTRY FORM CHAKAN",
        msgBody:
          "Mahindra @#appName# :@#OTP# is your OTP to login. Valid till @#time#",
        userAttempts: 3,
        loginLockTime: "3",
      })
      .then((res) => {
        if (res.data.error) {
          setOtpFieldVisible(false);
        } else {
          setOtpFieldVisible(true);
        }
        setCanResend(false);
        setTimeLeft(otpValidity);
        if (!res.data.message.includes("locked")) {
          toast.success("OTP has been sent to your mob no.");
        }
        setExpiredErr(res);
      })
      .catch((err) => {
        setOtpFieldVisible(false);
        toast.error(err?.message);
      })
      .finally(() => {
        setGettingLoad(false);
      });
  };

  // get OTP

  const getOTP = (e) => {
    setOtp(e.target.value);
  };

  // validate OTP

  const handleOtpValidate = () => {
    setGettingLoad(true);
    axios
      .post(`${getURLS().otpApiURL}/api/v1/PII/validateOTP`, {
        otp: otp,
        appId: getURLS().otpAppURL,
        mobileOrEmail: mobNumber,
        isEmail: false,
      })
      .then((res) => {
        if (!res.data.error) {
          setToken(mobNumber);
          navigate("entry_form");
          // window.location.reload();
        } else {
          // setOtpFieldVisible(false);
        }
        console.log({ res });
        setExpiredErr(res);
      })
      .catch((err) => {
        setOtpFieldVisible(false);
      })
      .finally(() => {
        setGettingLoad(false);
      });
  };

  return (
    <OTPAuthContext.Provider
      value={{
        handleOtpValidate,
        getOTP,
        onSendOtp,
        handleOTP,
        otpFieldVisible,
        errors,
        otp,
        mobNumber,
        expiredErr,
        timeLeft,
        setTimeLeft,
        canResend,
        setCanResend,
        otpGettingLoad,
      }}
    >
      {children}
    </OTPAuthContext.Provider>
  );
}

export default OTPAuthProvider;
